export interface FormatShareScoreTextParams {
    shareTextTitle: string;
    shareTextBody: string;
    shareUrl?: string;
    /** Registered user's active streak; omitted for guests */
    streak?: number | null;
    isRegistered: boolean;
    includeLink: boolean;
}

export interface FormattedShareScoreText {
    webText: string;
    mobileTitle: string;
    mobileText: string;
    mobileUrl: string;
}

/**
 * Builds clipboard / native-share text for puzzle and classic score sharing.
 * Registered users with an active streak get a 🔥 line after the title.
 */
export function formatShareScoreText(params: FormatShareScoreTextParams): FormattedShareScoreText {
    const title = params.shareTextTitle.trim();
    const bodyLines: string[] = [];
    if (params.isRegistered && params.streak != null && params.streak > 0) {
        bodyLines.push(`🔥 ${params.streak}-day streak`);
    }
    const gridBody = params.shareTextBody.trim();
    if (gridBody.length > 0) {
        bodyLines.push(gridBody);
    }
    const bodyBlock = bodyLines.join("\n");
    const includeUrl = params.includeLink && Boolean(params.shareUrl?.trim());
    const url = includeUrl ? (params.shareUrl as string).trim() : "";
    const webParts = [title];
    if (bodyBlock.length > 0) {
        webParts.push("", bodyBlock);
    }
    if (includeUrl) {
        webParts.push("", url);
    }
    return {
        webText: webParts.join("\n").trimEnd(),
        mobileTitle: title,
        mobileText: bodyBlock,
        mobileUrl: url,
    };
}
